export enum CustomFormType {
  CONTACT = 'CONTACT',
  IN_PERSON_EVENT = 'IN_PERSON_EVENT',
  SIGNUP = 'SIGNUP',
  SURVEY_CPD = 'SURVEY_CPD',
  VIRTUAL_EVENT = 'VIRTUAL_EVENT',
}
